import { loadScript, loadLink, isMobileBrowser } from './dom'
import { getQueryString } from './utils'

window.ROUTE_PREFIX = window.ROUTE_PREFIX || import.meta.env.VITE_PREFIX || ''
window.GA_ID = window.GA_ID || import.meta.env.VITE_GA_ID
window.IS_QA = window.IS_QA || import.meta.env.VITE_IS_QA === '1'
window.FTP_DOMAIN = window.FTP_DOMAIN || import.meta.env.VITE_FTP_DOMAIN
console.log(import.meta.env)
const enum SystemType {
  ILLUSTRATOR = 'ILST',
  PHOTOSHOP = 'PHXS',
  PHOTOSHOP_CC = 'PHSP',
  PREMIERE = 'PPRO',
  AEFT = 'AEFT',
  EDITOR = 'EDITOR',
}

function isInAdobe (st: string | null) {
  return [SystemType.ILLUSTRATOR, SystemType.PREMIERE, SystemType.PHOTOSHOP, SystemType.PHOTOSHOP_CC, SystemType.AEFT].includes(st as SystemType)
}

const systemType = sessionStorage.getItem('systemType') || getQueryString('systemType')

if (isInAdobe(systemType)) {
  window.IN_PLUGIN = true
  sessionStorage.setItem('systemType', systemType!)
  loadLink(`${location.origin}/${window.ROUTE_PREFIX}/adapter/adobePlugin.css`)
  if (import.meta.env.DEV) {
    import('@/adapter/adobePlugin/index')
  } else {
    loadScript(`${location.origin}/${window.ROUTE_PREFIX}/adapter/adobePlugin.js`)
  }
} else if (systemType === (SystemType.EDITOR)) {
  window.IN_PLUGIN = true
  sessionStorage.setItem('systemType', SystemType.EDITOR)
  loadScript(
    `${location.origin}/${window.ROUTE_PREFIX}/adapter/editorPlugin.js`
  )
  loadLink(`${location.origin}/${window.ROUTE_PREFIX}/adapter/adobePlugin.css`)
} else if (isMobileBrowser()) {
  loadLink(`${location.origin}/${window.ROUTE_PREFIX}/adapter/mobileBrower.css`)
  if (window.document.body.parentElement) {
    window.document.body.parentElement.style.fontSize = "13px";
    window.document.body.parentElement.classList.add('mobile')
  }
  document.addEventListener('touchstart', function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  }, { passive: false });

  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
}

window.dataLayer = window.dataLayer || []
function gtag (..._: any) {
  window.dataLayer.push(arguments)
}
gtag('js', new Date())

gtag('config', window.GA_ID)

loadScript(`https://www.googletagmanager.com/gtag/js?id=${window.GA_ID}`)

var analytics = (window.analytics = window.analytics || [])
if (!analytics.initialize)
  if (analytics.invoked)
    window.console &&
      console.error &&
      console.error('Segment snippet included twice.')
  else {
    analytics.invoked = !0
    analytics.methods = [
      'trackSubmit',
      'trackClick',
      'trackLink',
      'trackForm',
      'pageview',
      'identify',
      'reset',
      'group',
      'track',
      'ready',
      'alias',
      'debug',
      'page',
      'once',
      'off',
      'on',
      'addSourceMiddleware',
      'addIntegrationMiddleware',
      'setAnonymousId',
      'addDestinationMiddleware',
    ]
    analytics.factory = function (e: any) {
      return function () {
        var t = Array.prototype.slice.call(arguments)
        t.unshift(e)
        analytics.push(t)
        return analytics
      }
    }
    for (var e = 0; e < analytics.methods.length; e++) {
      var key = analytics.methods[e]
      analytics[key] = analytics.factory(key)
    }
    analytics.load = function (key: string, e: any) {
      var t = document.createElement('script')
      t.type = 'text/javascript'
      t.async = !0
      t.src =
        'https://cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js'
      var n = document.getElementsByTagName('script')[0]
      n.parentNode!.insertBefore(t, n)
      analytics._loadOptions = e
    }
    analytics._writeKey = 'GwOhwkLYyMzAsKEBsnfHX6Zw46XtB8Rw'
    analytics.SNIPPET_VERSION = '4.15.3'
    analytics.load('GwOhwkLYyMzAsKEBsnfHX6Zw46XtB8Rw')
    analytics.page()
  }
